import { Navigate, Outlet } from "react-router";
import { useMemo } from "react";
import { useAuthContext } from "../Auth";
import { ROUTES } from "@/router";
import qs from "qs";
import { AuthState } from "@/types/common";
import { AppLayout } from "@/components/AppLayout";

export const PrivatePage = () => {
  const { authenticated } = useAuthContext();

  const queryParams = useMemo(() => {
    return qs.parse(window.location.search, { ignoreQueryPrefix: true });
  }, []);

  const { email, newUser } = queryParams;

  if (authenticated === AuthState.Loading) {
    return null;
  }

  if (authenticated === AuthState.Unauthenticated) {
    const qsEmail = email ? `?email=${email}` : "";

    if (newUser === "true") {
      return <Navigate to={`/${ROUTES.AUTH}/${ROUTES.SIGN_UP}${qsEmail}`} />;
    }

    return <Navigate to={`/${ROUTES.AUTH}/${ROUTES.SIGN_IN}${qsEmail}`} />;
  }

  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
};
